import React from 'react';

export const CateringHeroImagesMobile = () => {
  return (
    <div className="catering-hero-images-mobile">
      <div className="catering-hero-image-wrap-1">
        <img
          src="https://img.peerspace.com/image/upload/v1725383524/kh9nhakrff6xfv4d1d36.jpg"
          alt="Catering hero image"
        />
      </div>
      <div className="catering-hero-image-wrap-2">
        <img
          src="https://img.peerspace.com/image/upload/v1725383524/3gu73wioonrgbg1aalop.jpg"
          alt="Catering hero image"
        />
      </div>
      <div className="catering-hero-image-wrap-3">
        <img
          src="https://img.peerspace.com/image/upload/v1725383524/ofe9mk0fw0x68ixy4b8s.jpg"
          alt="Catering hero image"
        />
      </div>
    </div>
  );
};
